import plantGroupsListSaga from 'modules/PlantGroups/saga/list';
import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';

export default function* PlantGroupsaga(): SagaIterator {
  yield fork(plantGroupsListSaga);
}
